module.exports = __webpack_public_path__ + "img/150.d22b6eae.jpg";